"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = void 0;
var SHORT_NUMBER = 5;

// const isShortNumber = (number: string): boolean => number?.length <= SHORT_NUMBER;

// export const formatNumber = (number: string, prefix?: string | null) : string => isShortNumber(number) ? number : `${prefix || ''}${number}`;

var isShortNumber = number => (number === null || number === void 0 ? void 0 : number.length) <= SHORT_NUMBER;
var formatNumber = (number, prefix) => isShortNumber(number) ? number : "".concat(prefix || '').concat(number);
exports.formatNumber = formatNumber;